










import { defineComponent, ref } from '@vue/composition-api'
import PageBuilderComponent from '~/mixins/solepro/PageBuilderComponent.vue';
import { PropType } from 'vue';
import { SliderType } from '~/types/solepro/PageBuilder';
import HomeHero from '../HomeHero.vue';

export default defineComponent({
    mixins: [PageBuilderComponent],
    props: {
        node: {
            type: Object as PropType<SliderType>,
            required: true
        }
    },
    components: {
        PageBuilderComponent,
        HomeHero //@TODO manage on lazy load
    },
    setup(props) {
        const { node: content } = props as Readonly<{ [key: string]: any }>;
        return {
            content
        }
    },
})
